export default "__VITE_ASSET__BX6uaUL9__"